import * as React from 'react'
import { BasicFeedback } from '@dooer/react-feedback'
import { useQuery, useMutation } from 'react-apollo'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import { ReactComponent as DooerLogo } from '../../components/dooer-logo/dooer-logo.svg'
import { getFeedbackQuestionQuery, createFeedbackResultMutation } from './gql'
import styles from './feedback.module.scss'
import Spinner from '../../components/spinner'

function Feedback(props: RouteComponentProps) {
  const history = useHistory()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { id, score } = props.match.params as any

  // Mutations and queries
  const { loading: getQuestionLoading, data: question } = useQuery(getFeedbackQuestionQuery, {
    variables: {
      id,
    },
    skip: !id,
  })

  const [createFeedbackResult, { loading: createResultLoading }] = useMutation(createFeedbackResultMutation)

  React.useEffect(() => {
    if (!getQuestionLoading) {
      if (question) {
        const { feedbackQuestion } = question

        // If the url contains a valid score, submit on mount
        if (Number(score) >= 0 && Number(score) <= 10) {
          createFeedbackResult({
            variables: {
              input: {
                score: Number(score),
                feedbackQuestionId: feedbackQuestion.id,
              },
            },
          })
        }
      } else {
        // If no question, navigate to '/byra'
        history.push('/byra')
      }
    }
  }, [createFeedbackResult, getQuestionLoading, history, question, score])

  return getQuestionLoading ? (
    <div className={styles.spinnerRoot}>
      <Spinner />
    </div>
  ) : (
    <div className={styles.root}>
      <DooerLogo />
      <BasicFeedback
        includeColors
        initialScore={Number(score)}
        loading={createResultLoading}
        onSubmit={async (chosenScore: number, chosenComment?: string | null) => {
          if (question) {
            await createFeedbackResult({
              variables: {
                input: {
                  feedbackQuestionId: question.feedbackQuestion.id,
                  score: chosenScore,
                  feedback: chosenComment,
                },
              },
            })
          }
        }}
        question={question && question.feedbackQuestion}
        style={{ maxWidth: '450px' }}
      />
    </div>
  )
}

export default Feedback
